import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'
import BackButton from '../.././components/BackButton'

interface ContentProps {
  isStacked?: boolean
}

interface HeaderProps {
  children: ReactNode
  isStacked?: boolean
}

export const Container = styled.div`
  margin: 8px 0;
  width: 100%;
`

const HeaderWrapper = styled.div`
  height: 50px;
  display: flex;
  margin-bottom: 40px;
`

export const Content = styled.div<ContentProps>`
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: ${({ isStacked }) => (isStacked ? 'column' : 'row')};
  width: 100%;
  justify-content: space-between;
  padding: 8px;
`

export const AssessmentWrapper = styled.div`
  margin: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Header = ({ children, isStacked }: HeaderProps): ReactElement => {
  const history = useHistory()
  return (
    <HeaderWrapper>
      <BackButton handleBack={() => history.goBack()} />
      <Content isStacked={isStacked}>{children}</Content>
    </HeaderWrapper>
  )
}
